import { render } from "./Tal_moTheAlim.vue?vue&type=template&id=102fd914"
import script from "./Tal_moTheAlim.vue?vue&type=script&lang=js"
export * from "./Tal_moTheAlim.vue?vue&type=script&lang=js"

import "./Tal_moTheAlim.vue?vue&type=style&index=0&id=102fd914&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__